module.exports = __webpack_public_path__ + "img/bluemedia.ebe71989.png";